import React from "react";
import "./Hero3.css";
import img1 from "../assets/h1.png";
import img2 from "../assets/h2.png";
import img3 from "../assets/h3.png";
import img4 from "../assets/h4.png";
import img5 from "../assets/h5.png";
import img6 from "../assets/h6.png";

export default function Hero3() {
  return (
    <section className="hero3">
      <div className="hero3-floating-images">
        <img src={img1} className="img-box a" alt="col1" />
        <img src={img2} className="img-box b" alt="col2" />
        <img src={img3} className="img-box a" alt="col3" />
        <img src={img4} className="img-box b" alt="col4" />
        <img src={img5} className="img-box a" alt="col5" />
        <img src={img6} className="img-box b" alt="col6" />
      </div>
      <div className="hero3-overlay"></div>
      <div className="hero3-content">
        <h1>Shop Pakistan's Top Paint Brands</h1>
        <p>
          Elevate Your Projects with Our Premium Paints and A Comprehensive
          Selection of Paints and Accessories
        </p>
        <button>Order your paint now</button>
      </div>
    </section>
  );
}
